import { sendTrackingEvent, getSlideshowId } from "./base-tracker"

function getPageKey() {
  return (window.slideshare_object && window.slideshare_object.page_key) || null
}

if (window.feature_flags.frontendPageViewEvents) {
  sendTrackingEvent("frontend_page_view_event_stream", {
    path: window.location.pathname,
    slideshow_id: getSlideshowId(),
    page_key: getPageKey(),
  })
}
